import "./awardCard.css";

export default function AwardCard({
  title,
  event,
  location,
  year,
  countryFlag,
  countryName = "",
}) {
  return (
    <article className="award-card">
      <div className="award-card-content">
        <div className="award-title-row">
          <h3>{title}</h3>

          {countryFlag && (
            <span className="award-country-flag">
              <img
                src={countryFlag}
                alt={countryName ? `${countryName} flag` : "Award country flag"}
              />
            </span>
          )}
        </div>

        {event && <h4>{event}</h4>}

        <div className="award-meta">
          {location && <span>{location}</span>}
          {year && <span>{year}</span>}
        </div>
      </div>
    </article>
  );
}